
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/advocacy/state/environment-report",
      function () {
        return require("private-next-pages/advocacy/state/environment-report/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/advocacy/state/environment-report"])
      });
    }
  